import { init, RematchDispatch, RematchRootState } from '@rematch/core';
import immerPlugin from '@rematch/immer';
import loading, { ExtraModelsFromLoading } from '@rematch/loading';
import persist from '@rematch/persist';
import selectPlugin from '@rematch/select';
import updated, { ExtraModelsFromUpdated } from '@rematch/updated';
import { iRootModel, rootModels } from './iRootModel';
//import {signalRInvokeMiddleware} from "fulogics-ui-core/dist/store/middlewares/signalRInvokeMiddleware";
//import {createReactRouterPlugin} from "fulogics-ui-web/dist/store/navigator";
import { Singleton } from 'fulogics-ui-core/dist/Singleton';
import { createReactRouterPlugin } from 'fulogics-ui-web/dist/store/navigator';
import * as ReduxHistory from 'history';
import storage from 'redux-persist/lib/storage';

type FullModel = ExtraModelsFromLoading<iRootModel> & ExtraModelsFromUpdated<iRootModel>;

export const history = ReduxHistory.createBrowserHistory();

const legacyReducers = {};

const persist_Key = `${Singleton.getInstance().coreConfiguration.APP_NAME}_PERSIST`;

export const store = init<iRootModel, FullModel>({
    models: rootModels,
    plugins: [
        createReactRouterPlugin({
            history,
        }),
        updated(),
        loading(),
        persist({
            key: persist_Key,
            storage: storage,
            version: 2,
            //whitelist: ['persisted'],
        }),
        immerPlugin({}),
        selectPlugin(),
    ],
    redux: {
        reducers: {
            ...legacyReducers,
        },
    },
});
//
export type Store = typeof store;
export type iRootDispatch = RematchDispatch<iRootModel>;
export type iRootState = RematchRootState<iRootModel, FullModel>;

export const select = store.select;
